import * as React from 'react';

import {getApiTypeFromGraphQLTypename} from 'nutshell-core/utils';

import type {EventFragmentSparse_actor as Actor} from 'nutshell-graphql-types';

import {LinkedEntity} from '../../linked-entity/linked-entity';
import {SpacerGroup} from '../../spacer/spacer-group';

import TimelineHeaderTimestamp from '../entry/header/timeline-header-timestamp';

import styles from '../entry/header/timeline-header.module.css';

type Props = {
    timestamp: number;
    actor: Actor | null | undefined;
    action: React.ReactElement<any>;
    isSmall?: boolean;
    omitActor?: boolean;
};

export function TimelineBannerContent(props: Props) {
    const {timestamp, actor, action, isSmall, omitActor} = props;

    const getDefaultActor = () => {
        if (omitActor) {
            return undefined;
        } else {
            return <span>Someone</span>;
        }
    };

    return (
        <div className={isSmall ? styles['header-container--small'] : styles['header-container']}>
            <SpacerGroup mb={4}>
                <TimelineHeaderTimestamp timestamp={timestamp} />
            </SpacerGroup>
            <div className={styles['action-text']}>
                {actor ? (
                    <span className={styles.actor}>
                        <LinkedEntity
                            useEntityColor={true}
                            shouldClientRoute={true}
                            type={getApiTypeFromGraphQLTypename(actor.__typename)}
                            displayInline={true}
                            allowWrap={true}
                            {...actor}
                        />
                    </span>
                ) : (
                    getDefaultActor()
                )}
                &nbsp;
                <span className={styles.verb}>{action}</span>
            </div>
        </div>
    );
}
